import SurgicalOrderDetails from "./SurgicalOrderDetails";
import { SurgicalCaseDetailsSectionV2 } from "../../Components/Order-Comps/SurgicalCaseDetailsSectionV2";

function SurgicalOrderDetailsV2(props) {
  return <SurgicalOrderDetails {...props} CaseDetailsComponent={SurgicalCaseDetailsSectionV2} />;
}

export default SurgicalOrderDetailsV2;
